import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function ProductOrderDeliveryHistoryMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.product.order.delivery.history);
  };

  return (
    <MainMenuItem
      itemTitleString="発送履歴を見る"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default ProductOrderDeliveryHistoryMenuItem;
